import { FC } from 'react';

import { Button, ButtonProps } from '@purpur/library';
import { Icon } from '@purpur/library/icon';
import { minus } from '@purpur/library/icon/assets/minus';
import { plus } from '@purpur/library/icon/assets/plus';

const iconMap = {
    plus,
    minus,
} as const;

type Props = { dataTest?: string; iconVariant: 'plus' | 'minus'; ariaLabel: string; ariaControls?: string } & Pick<
    ButtonProps,
    'disabled' | 'onClick'
>;

export const RoundButton: FC<Props> = ({ iconVariant, disabled, onClick, dataTest, ariaLabel, ariaControls }) => (
    <Button
        iconOnly={true}
        variant="secondary"
        size="md"
        onClick={onClick}
        disabled={disabled}
        data-test={dataTest}
        aria-label={ariaLabel}
        aria-controls={ariaControls}
    >
        <Icon svg={iconMap[iconVariant]} size="sm" />
    </Button>
);
